import { preferencesAreLoaded } from '../brand/brandSelectors';
import { isStillFetchingPromoRewards } from '../promo/promoSelectors';

import { paymentStepPreConditions, paymentStepPostConditions } from './paymentStepSelectors';



const paymentStepConfig = {
    component: () => import('./PaymentStep'),
    flow: 'postBuy',
    hideCartLink: true,
    hidePromoBanner: true,
    isReady: state => preferencesAreLoaded(state) && !isStillFetchingPromoRewards(state),
    preConditions: paymentStepPreConditions,
    postConditions: paymentStepPostConditions,
    
    getSubmitMessage: null,
    canSkip: null 
};

export default paymentStepConfig;
